import { render } from "./SideMenu.vue?vue&type=template&id=fb2e6e8c&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=fb2e6e8c&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2e6e8c"]])

export default __exports__